import { useTheme } from '@mui/material';

export const IntroIcon3 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 13C7 11.8954 7.89543 11 9 11H34C35.1046 11 36 11.8954 36 13V26C36 28.7614 33.7614 31 31 31H9C7.89543 31 7 30.1046 7 29V13Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 9.5H30C31.3807 9.5 32.5 10.6193 32.5 12V14.75H5.5V12C5.5 10.6193 6.61929 9.5 8 9.5ZM5.5 16.25V25C5.5 26.3807 6.61929 27.5 8 27.5H30C31.3807 27.5 32.5 26.3807 32.5 25V16.25H5.5ZM4 12C4 9.79086 5.79086 8 8 8H30C32.2091 8 34 9.79086 34 12V25C34 27.2091 32.2091 29 30 29H8C5.79086 29 4 27.2091 4 25V12ZM8 22.75C7.58579 22.75 7.25 23.0858 7.25 23.5C7.25 23.9142 7.58579 24.25 8 24.25H12.5C12.9142 24.25 13.25 23.9142 13.25 23.5C13.25 23.0858 12.9142 22.75 12.5 22.75H8ZM15 22.75C14.5858 22.75 14.25 23.0858 14.25 23.5C14.25 23.9142 14.5858 24.25 15 24.25H17C17.4142 24.25 17.75 23.9142 17.75 23.5C17.75 23.0858 17.4142 22.75 17 22.75H15Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
